import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router';
import { CommonConfig } from '../../config/common-config';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    blueMainTile: {
        background: '#4e4cac',
        borderRadius: '6px',
        padding: '20px',
        display: 'flex',
    },
    intHeading: {
        color: '#ffffff',
        fontSize: '16px',
        fontFamily: 'Rubik',
        textTransform: 'capitalize',
        fontWeight: '400',
        paddingLeft: '20px',
        margin: '0',
        '& div': {
            fontSize: '12px',
            fontWeight: '100',
        },
    },
    imcNo: {
        color: '#ffffff',
        padding: '12px 20px',
        background: '#5c5ab9',
        fontSize: '25px',
        fontFamily: 'Rubik',
        borderRadius: '6px',
    },
    currsorPointer: {
        cursor: 'pointer',
    },
}));

export default function CorpClients() {
    const classes = useStyles();
    const history = useHistory();

    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const { tennantName } = tennantDetails;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };

    const navigate = () => {
        history.push('/menu/ClientCorporateView');
    };

    const [rows, setTotalReactPackages] = useState([]);

    useEffect((data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${tennantName}?page=0&size=1000`, axiosConfig)

            .then((response) => {
                setTotalReactPackages(response.data.content);
                //console.log('response', response);
            })
            .catch((error) => {});
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                    <Paper className={classes.blueMainTile}>
                        <Typography variant="h4" className={classes.imcNo}>
                            {rows.length}
                        </Typography>
                        <Typography className={classes.intHeading} variant="button" display="block" gutterBottom>
                            Clients (Corp clients)
                            <div className={classes.currsorPointer} onClick={navigate}>
                                View More
                            </div>
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
}
